module.exports = __webpack_public_path__ + "img/delete.d9934947.svg";